var path = '/var/www/mmscny-website/src/app/common/components/loader/loader.html';
var html = "<div class=overlay> <div class=overlay-content> <img src=/./images/loader.svg alt=loader...> <button class=btn-cancel ng-if=$ctrl._showTryAgainButton ng-click=$ctrl.onTryAgain()>Try again</button> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/loader/loader.html
// module id = 651
// module chunks = 0